import React, { useEffect, useState } from 'react'
import Text from 'components/_UI/Text';
import ButtonSelect from 'components/_UI/ButtonSelect';
import Fieldset from 'components/_UI/Fieldset';
import { Column } from 'styled/alignment/Column';
import { ButtonSelectItem, SelectContainer, SelectWrapper } from 'components/_UI/SelectsContent';
import styled from 'styled-components';
import colors from 'theme/colors';
import { Row } from 'styled/alignment/Row';
import Button from 'components/_UI/Button';
import { useEvent } from 'context/events/Event';
import BasicInfos from './parts/BasicInfos';
import CategoriesInfo from './parts/CategoriesInfo';
import AddressInfo from './parts/AddressInfo';
import ExtraInfo from './parts/ExtraInfo';
import { useForm } from 'react-hook-form';
import eventsApi from 'api/requests/events';
import date from 'helpers/date';
import { useCollapse } from 'context/general/Collapse';
import EventDetail from '../detail/EventDetail';
import { useEventsList } from 'context/events/EventsList';
import Loader from 'components/_UI/Loader';
import { FullyCentered } from 'styled/alignment/Center';
import ImageInfo from './parts/ImageInfo';
import eventTypes from 'theme/eventTypes';
import imageUpload from 'api/requests/imageUpload';
import buttonText from 'texts/buttons/buttonText';
import CreateEvent from 'screens/CreateEvent';


export default function EventForm({ edit }) {
    const { event, setEvent } = useEvent();
    const { collapse, setCollapse } = useCollapse();
    const { eventsList, setEventsList } = useEventsList();

    const [trigger, setTrigger] = useState(false);
    const [tagsError, setTagsError] = useState(false);
    const [errorImage, setErrorImage] = useState(false);

    const {
        register,
        handleSubmit,
        formState: { errors }
    } = useForm({
        defaultValues: !edit ? {} : {
            name: edit?.name,
            description: edit?.description,
            ...datesToEdit(edit?.dates)
        }
    });

    function datesToEdit(data) {
        const transformedResponse = {};

        Object.keys(data).forEach(key => {
            const item = data[key];
            const index = Number(key) + 1;

            transformedResponse[`date${index}`] = item.date;
            transformedResponse[`start${index}`] = item.start;
            transformedResponse[`end${index}`] = item.end;
        });
        console.log(transformedResponse)
        return transformedResponse;
    }

    function removeDuplicates(obj) {
        const result = obj;

        for (const key in result) {
            if (key.startsWith('start') || key.startsWith('end') || key.startsWith('date')) {
                delete result[key];
            }
        }

        return result;
    }

    function createDatesPayload(content) {
        const result = [];
        const regex = /^date\d+$/;
        let count = 0;

        for (const key in content) {
            if (regex.test(key)) {
                count++;
            }
        }

        for (let i = 1; i <= count; i++) {
            const dateKey = "date" + i;
            const startKey = "start" + i;
            const endKey = "end" + i;

            if (content[dateKey] && content[startKey] && content[endKey]) {
                result.push({
                    date: date.unformat(content[dateKey]),
                    start: `${content[startKey]}:00`,
                    end: `${content[endKey]}:00`
                });
            }
        }

        return result;
    }

    async function onToggleDelete() {
        const id = event?.images_id.length &&  event.images_id[0]
        try {
            const {data} = await imageUpload.delete(id)
            console.log(data);
        } catch (error) {
            console.log(error);
        }
    }

    async function uploadImage(file) {
        const formData = new FormData()
        console.log('1')
        formData.append('image', file)
        formData.append('folder', 'events')

        try {
            console.log('2')
            const { data } = await imageUpload.uploadWithFolder(formData)
            console.log(data);
            console.log('4')
            setEvent({ ...event, images_id: [data.id] })
        } catch (error) {
            console.log('3')
            setErrorImage(true)
            console.log('soluco`')
        }
    }

    function isValidTags() {
        if (event && event.tags) {
            if (event.tags.length > 3) {
                setTagsError('max');
                return false;
            }

            if (event.tags.length <= 0) {
                setTagsError('min');
                return false;
            }

            return true;
        }
    }

    function createPayload(content) {
        const data = content

        if (!data?.link_ticket) {
            delete data.link_ticket
        }

        return {
            address: event.address,
            dates: createDatesPayload(content),
            ...removeDuplicates(content),
            ...event,
            tags: event?.tags.map(el => el.id),
            classification_id: event.classification_id || eventTypes.free.id,
        }
    }

    async function createEvent(content) {
        if (!isValidTags()) {
            return;
        }

        setCollapse({
            ...collapse,
            withContent: true,
            height: '85vh',
            arrowPosition: false,
            componentToRender: () => {
                return (
                    <LoaderContainer>
                        <Loader />
                    </LoaderContainer>
                );
            }
        });

        const payload = createPayload(content);

        try {
            setTagsError(false);

            const { data } = await eventsApi.create(payload);

            setCollapse({
                ...collapse,
                withContent: true,
                height: '95vh',
                arrowPosition: false,
                componentToRender: () => data?.address && <EventDetail data={data} />
            });

            setEventsList([...eventsList, data]);
        } catch (error) {
            setCollapse({
                ...collapse,
                withContent: true,
                height: '65vh',
                arrowPosition: false,
                componentToRender: () => {
                    return (
                        <Column fullyCentralized height='100%'>
                            <Text name='highlight'>Ops... Ocorreu um erro inesperado.</Text>
                            <Column fullyCentralized>
                                <Column width='200px' marginTop='14px'>
                                    <Button onClick={() => {
                                        setCollapse({
                                            ...collapse,
                                            withContent: true,
                                            height: '95vh',
                                            arrowPosition: false,
                                            componentToRender: () => <CreateEvent />
                                        });
                                    }}
                                    >
                                        {buttonText.tryAgain}
                                    </Button>
                                </Column>
                            </Column>
                        </Column>
                    );
                }
            });
        }
    }

    return (
        <FormContainer onSubmit={handleSubmit(createEvent)}>
            <Text name='title'>Criar Evento</Text>

            <BasicInfos register={register} errors={errors} edit={edit} />
            <ImageInfo 
                onToggleImage={(e) => uploadImage(e)} 
                onDeleteFile={() => onToggleDelete()}
                errorImage={errorImage}
            />
            <CategoriesInfo error={tagsError} />
            <AddressInfo trigger={trigger} />
            <ExtraInfo register={register} errors={errors} />

            <span onClick={() => setTrigger(true)}>
                <Button
                    marginTop={'18px'}
                    paddingBottom={'30px'}
                    type="submit"
                >
                    Criar evento
                </Button>
            </span>
            <br></br>
        </FormContainer>

    )
};

const FormContainer = styled.form`
    height: 100%;
    padding: 46px 0;
    text-align: center;
    padding-bottom: 40px;
`;

const LoaderContainer = styled(FullyCentered)`
    width: 100%;
    height: 100%;
`;
